/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/stop_square'
export default icon
